import { FormEvent, useState } from "react";

const SUGGESTIONS = [
  "What does the Quran say about charity?",
  "How should one fast?",
  "The meaning of Taqwa",
  "Guidance on patience",
];

export function EmptyChat({ onAsk }: { onAsk: (q: string) => void }) {
  const [question, setQuestion] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const text = question.trim();
    if (!text) return;
    onAsk(text);
    setQuestion("");
  };

  return (
    <div className="sa-empty-chat">
      <div style={{ maxWidth: 560, width: "100%", textAlign: "center" }}>
        <div className="sa-label" style={{ marginBottom: 20 }}>
          A New Inquiry
        </div>
        <h1
          className="sa-empty-chat__title"
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 400,
            fontSize: 44,
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            margin: "0 0 40px",
            fontStyle: "italic",
          }}
        >
          What would you ask?
        </h1>
        <form
          className="sa-empty-chat__form"
          onSubmit={submit}
          style={{
            display: "flex",
            alignItems: "stretch",
            border: "1px solid var(--sa-border-strong)",
            background: "var(--sa-bg-pure)",
            borderRadius: 2,
          }}
        >
          <input
            className="sa-empty-chat__input"
            autoFocus
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Ask a question..."
            maxLength={2000}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              padding: "18px 20px",
              fontFamily: "var(--sa-serif)",
              fontSize: 17,
              background: "transparent",
              color: "var(--sa-fg)",
            }}
          />
          <button
            type="submit"
            className="sa-btn"
            style={{ borderRadius: 0, padding: "0 22px", fontSize: 12, flexShrink: 0 }}
            disabled={!question.trim()}
          >
            Ask {"->"}
          </button>
        </form>
        <div
          style={{
            marginTop: 36,
            display: "flex",
            gap: 10,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {SUGGESTIONS.map((suggestion) => (
            <button
              key={suggestion}
              onClick={() => setQuestion(suggestion)}
              style={{
                fontFamily: "var(--sa-serif)",
                fontStyle: "italic",
                fontSize: 13,
                padding: "6px 12px",
                border: "1px solid var(--sa-border)",
                background: "var(--sa-bg-pure)",
                color: "var(--sa-muted-fg)",
                cursor: "pointer",
                borderRadius: 2,
              }}
            >
              "{suggestion}"
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
